"use strict";
var ExposeMetadata = (function () {
    function ExposeMetadata(target, propertyName, options) {
        this.target = target;
        this.propertyName = propertyName;
        this.options = options;
    }
    return ExposeMetadata;
}());
exports.ExposeMetadata = ExposeMetadata;

//# sourceMappingURL=ExposeMetadata.js.map



//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/metadata/ExposeMetadata.js
// module id = 1452
// module chunks = 3